import { Button, Col, Row } from 'react-bootstrap';


const ConfirmationArea = ({question="Sind Sie sicher ?", handleDelete, handleCancel}) =>{
      return(
          <div className="mt-4 p-2">
            <h6 className="mb-4">{question}</h6>
            <Row>
                    <Col>
                        <Button block className = "btn-danger" onClick={handleDelete}>Ja</Button>
                    </Col>
                    <Col>
                        <Button block className = "btn-secondary" onClick={handleCancel}>Nein</Button>
                    </Col>
                </Row>
          </div>
      );
};

export default ConfirmationArea;